import { RES_LOAD, RES_UPDATE } from './actionType';

import axios from '../../axios-default';
import { ROLE_NAMES } from '../../util/const';
import { RES_CONFIG_KEY } from './utils';

let isLoading = false;

const resLoad = (payload) => ({
    type: RES_LOAD,
    payload,
});
const resUpdate = (payload) => ({
    type: RES_UPDATE,
    payload,
});

/**
 * @param {boolean} isAuthenticated - boolean for verify user's login status, should get from store by the same key
 */
// Please pass isAuthenticated from useAuth hook as function's params
export const loadRes = (isAuthenticated) => async (dispatch) => {
    // only load below data when user is logged in
    if (!isAuthenticated) {
        // please check isAuthenticated from params of this function & value in store
        console.error(
            'Invalid login status, Please check function params first then check isAuthenticated state value'
        );
        return;
    }

    if (!isLoading) {
        isLoading = true;

        try {
            const resultMap = {};
            // const updatedObj = {}
            const role = JSON.parse(localStorage.getItem('role'));
            const isRoleAllowGetAdminGroup = [ROLE_NAMES.admin, ROLE_NAMES.super_admin].includes(role);
            try {
                const [
                    {
                        data: { country },
                    },
                    {
                        data: { state_province },
                    },
                ] = await Promise.all([axios.get(`res/country`), axios.get(`res/state_province`)]);
                const isCountryValid = Array.isArray(country) && country.length > 0;
                resultMap.countries = isCountryValid ? country : []; // remain order from API (order by counrty name in alphabetical order: A-Z)
                // updatedObj.countries = country?.reduce((a, c) => Object.assign(a, { [c.country_id]: c }), {}) ?? {}
                // keep stateProvinces based on the orginal approach has been widely used in the project
                resultMap.stateProvinces =
                    state_province?.reduce((a, s) => Object.assign(a, { [s.state_province_id]: s }), {}) ?? {};
                resultMap.stateProvincesList =
                    Array.isArray(state_province) && state_province.length > 0 ? state_province : [];
            } catch (e) {
                console.error(e);
            }

            const resourceApiConfigs = [
                { key: RES_CONFIG_KEY.promotionCountry, url: `res/promotionCountry`, shouldCall: true },
                { key: RES_CONFIG_KEY.clinics, url: `res/clinic`, shouldCall: true },
                { key: RES_CONFIG_KEY.groups, url: `res/group`, shouldCall: true },
                { key: RES_CONFIG_KEY.admin_group, url: `res/admingroup`, shouldCall: isRoleAllowGetAdminGroup },
                { key: RES_CONFIG_KEY.distr_groups, url: `res/distrgroup`, shouldCall: true },
                { key: RES_CONFIG_KEY.acc_distr_groups, url: `res/accdistrgroup`, shouldCall: true },
                { key: RES_CONFIG_KEY.form_download, url: `res/formdownload`, shouldCall: true },
                { key: RES_CONFIG_KEY.knowledge_base, url: `res/knowledgebase`, shouldCall: true },
            ];

            const filteredConfigs = resourceApiConfigs.filter((cfg) => cfg.shouldCall);
            const results = await Promise.allSettled(filteredConfigs.map((cfg) => axios.get(cfg.url)));
            filteredConfigs.forEach((cfg, idx) => {
                let value = {};
                const response = results[idx];
                switch (cfg.key) {
                    case RES_CONFIG_KEY.promotionCountry:
                        if (response.status === 'fulfilled') {
                            value =
                                response?.value?.data?.country?.reduce(
                                    (a, c) => Object.assign(a, { [c.country_id]: c }),
                                    {}
                                ) ?? {};
                        }
                        break;
                    case RES_CONFIG_KEY.clinics:
                        if (response.status === 'fulfilled') {
                            value =
                                response?.value?.data?.clinic?.reduce?.(
                                    (a, c) => Object.assign(a, { [c.clinic_id]: c }),
                                    {}
                                ) ?? {};
                        }
                        break;
                    case RES_CONFIG_KEY.groups:
                        if (response.status === 'fulfilled') {
                            value =
                                response?.value?.data?.group?.reduce?.(
                                    (a, g) => Object.assign(a, { [g.group_id]: g }),
                                    {}
                                ) ?? {};
                        }
                        break;
                    case RES_CONFIG_KEY.admin_group:
                        if (response.status === 'fulfilled') {
                            value =
                                response?.value?.data?.admin_group?.reduce?.(
                                    (a, ag) => Object.assign(a, { [ag.admin_group_id]: ag }),
                                    {}
                                ) ?? {};
                        }
                        break;
                    case RES_CONFIG_KEY.distr_groups:
                        if (response.status === 'fulfilled') {
                            value =
                                response?.value?.data?.distr_group?.reduce?.(
                                    (a, dg) => Object.assign(a, { [dg.distr_group_id]: dg }),
                                    {}
                                ) ?? {};
                        }
                        break;
                    case RES_CONFIG_KEY.acc_distr_groups:
                        if (response.status === 'fulfilled') {
                            value =
                                response?.value?.data?.acc_distr_groups?.reduce?.(
                                    (a, accdg) => Object.assign(a, { [accdg.distr_group_id]: accdg }),
                                    {}
                                ) ?? {};
                        }
                        break;
                    case RES_CONFIG_KEY.form_download:
                        if (response.status === 'fulfilled') {
                            value =
                                response?.value?.data?.forms?.reduce?.((a, c) => {
                                    if (!Object.hasOwn(a, c.distr_group_id)) a[c.distr_group_id] = [];
                                    a[c.distr_group_id].push({
                                        ...c,
                                        display_sequence_number: parseInt(c.display_sequence_number),
                                    });
                                    return a;
                                }, {}) ?? {};
                        }
                        break;
                    case RES_CONFIG_KEY.knowledge_base:
                        if (response.status === 'fulfilled') {
                            resultMap.knowledge_base_article =
                                response?.value?.data?.knowledgeBase?.article?.reduce?.(
                                    (a, g) => Object.assign(a, { [g.knowledge_base_id]: g }),
                                    {}
                                ) ?? {};
                            resultMap.knowledge_base_video =
                                response?.value?.data?.knowledgeBase?.video?.reduce?.(
                                    (a, g) => Object.assign(a, { [g.knowledge_base_id]: g }),
                                    {}
                                ) ?? {};
                        }
                        break;
                    default:
                        break;
                }
                if (cfg.key !== RES_CONFIG_KEY.knowledge_base) {
                    resultMap[cfg.key] = value;
                }
            });
            await dispatch(resLoad(resultMap));
        } catch (e) {
            console.error(e);
        } finally {
            isLoading = false;
        }
    }
};

export const updateRes = (resName) => async (dispatch) => {
    try {
        const updatedObj = {};
        switch (resName) {
            case 'country':
            case 'countries': {
                // updatedObj.countries = (await axios.get(`res/country`)).data.country.reduce((a, c) => Object.assign(a, { [c.country_id]: c }), {})
                updatedObj.countries = (await axios.get(`res/country`)).data.country;
                break;
            }
            case 'state_province':
            case 'state_provinces':
            case 'stateProvince':
            case 'stateProvinces': {
                updatedObj.stateProvinces = (await axios.get(`res/state_province`)).data.state_province.reduce(
                    (a, s) => Object.assign(a, { [s.state_province_id]: s }),
                    {}
                );
                break;
            }
            case 'group':
            case 'groups': {
                updatedObj.groups = (await axios.get(`res/group`)).data.group.reduce(
                    (a, g) => Object.assign(a, { [g.group_id]: g }),
                    {}
                );
                break;
            }
            case 'admingroup':
            case 'admingroups':
            case 'admin_group':
            case 'admin_groups': {
                updatedObj.admin_groups = (await axios.get(`res/admingroup`)).data.admin_group.reduce(
                    (a, ag) => Object.assign(a, { [ag.admin_group_id]: ag }),
                    {}
                );
                break;
            }
            case 'distrgroup':
            case 'distrgroups':
            case 'distr_group':
            case 'distr_groups': {
                updatedObj.distr_groups = (await axios.get(`res/distrgroup`)).data.distr_group.reduce(
                    (a, dg) => Object.assign(a, { [dg.distr_group_id]: dg }),
                    {}
                );
                break;
            }
            case 'acc_distr_groups': {
                updatedObj.acc_distr_groups = (await axios.get(`res/accdistrgroup`)).data.acc_distr_groups.reduce(
                    (a, dg) => Object.assign(a, { [dg.distr_group_id]: dg }),
                    {}
                );

                break;
            }
            case 'clinic':
            case 'clinics': {
                updatedObj.clinics = (await axios.get(`res/clinic`)).data.clinic.reduce(
                    (a, c) => Object.assign(a, { [c.clinic_id]: c }),
                    {}
                );
                break;
            }
            case 'form_download':
            case 'formdownload': {
                updatedObj.form_download =
                    (await axios.get(`res/formdownload`)).data.forms.reduce?.((a, c) => {
                        if (!Object.hasOwn(a, c.distr_group_id)) a[c.distr_group_id] = [];
                        a[c.distr_group_id].push({
                            ...c,
                            display_sequence_number: parseInt(c.display_sequence_number),
                        });
                        return a;
                    }, {}) ?? {};
                break;
            }
            case 'knowledge_base':
            case 'knowledgebase':
            case 'knowledgeBase':
                const knowledgeBaseRet = await axios.get(`res/knowledgebase`);
                updatedObj.knowledge_base_article =
                    knowledgeBaseRet?.data?.knowledgeBase?.article?.reduce?.(
                        (a, g) => Object.assign(a, { [g.knowledge_base_id]: g }),
                        {}
                    ) ?? {};
                updatedObj.knowledge_base_video =
                    knowledgeBaseRet?.data?.knowledgeBase?.video?.reduce?.(
                        (a, g) => Object.assign(a, { [g.knowledge_base_id]: g }),
                        {}
                    ) ?? {};
                break;
        }
        dispatch(resUpdate(updatedObj));
    } catch (e) {
        console.error(e);
    }
};
